export default __webpack_public_path__ + "static/media/pdf-mini.d96a044d.svg";